module.exports = __webpack_public_path__ + "img/20190523212205微信截图_20190523212603.e9c1f13d.png";